import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import HomeComponent from './components/HomeComponent'
import Descubre from './components/Descubre'
import Regala from './components/Regala'
import Nosotros from './components/Nosotros'
import Participa from './components/Participa'
import CategoriesComponent from './components/CategoriesComponent'
import Mishnayot from './components/Mishnayot'
import SubCategoriesComponent from './components/SubCategoriesComponent'
import LessonComponent from './components/LessonComponent'
import StoreRootComponent from './components/StoreRootComponent'
import StoreTalmudComponent from './components/StoreTalmudComponent'
import StoreItemComponent from './components/StoreItemComponent'
import StoreDigitalItemComponent from './components/StoreDigitalItemComponent'
import CartComponent from './components/CartComponent'
import DedicationRoot from './components/DedicationRoot'
import Donations from './components/Donations'
import ContactComponent from './components/ContactComponent'
import DedicationDay from './components/DedicationDay'
import UserDataComponent from './components/UserDataComponent'
import Profile from './components/Profile'
import About from './components/About'
import PoliticaDePrivacidad from './components/PoliticaDePrivacidad'
import TerminosYCondiciones from './components/TerminosYCondiciones'

import vanilla from './services/vanilla'

import {
    ROUTE_ROOT,
    ROUTE_STORE_ROOT,
    ROUTE_STORE_DIGITAL_ITEM,
    ROUTE_STORE_SIDDER,
    ROUTE_STORE_TALMUD_ITEM,
    ROUTE_DEDICATION_DAY,
    ROUTE_CART,
    ROUTE_ABOUT,
    ROUTE_MISHNAYOT,
    GET_LOGGED_IN,
    SET_SIGNUP_SHOW_STATE,
    A_AFTER_NAVIGATION,
} from './services/constants'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomeComponent,
        },
        {
            path: '/log',
            name: 'log',
            component: UserDataComponent,
        },
        {
            path: '/descubre',
            name: 'descubre',
            component: Descubre,
        },
        {
            path: '/participa',
            name: 'participa',
            component: Participa,
        },
        {
            path: '/nosotros',
            name: 'nosotros',
            component: Nosotros,
        },
        {
            path: '/regala',
            name: 'regala',
            component: Regala,
        },
        {
            path: '/mishnayot',
            name: ROUTE_MISHNAYOT,
            component: Mishnayot
        },
        {
            path: '/estudia',
            name: 'categories',
            component: CategoriesComponent
        },
        {
            path: '/categories/:id',
            name: 'subcategory',
            component: SubCategoriesComponent
        },
        {
            path: '/lesson/:id',
            name: 'lesson',
            component: LessonComponent,
            beforeEnter: (to, from, next) => {
                isLoggedIn(to, from, next)
            }
            // component: () => {
            //     console.log('dynamically loading the lesson component and its dependencies')
            //     return import(/* webpackChunkName: "lesson" */ './components/LessonComponent')
            // }

        },
        {
            path: '/store',
            name: ROUTE_STORE_ROOT,
            // component: StoreRootComponent
            component: Mishnayot
        },
        {
            path: '/store/talmud',
            name: 'storeTalmud',
            component: StoreTalmudComponent
        },
        {
            path: '/store/talmud/:id',
            name: ROUTE_STORE_TALMUD_ITEM,
            component: StoreItemComponent
        },
        {
            path: '/store/siddur',
            name: ROUTE_STORE_SIDDER,
            component: StoreItemComponent
        },
        {
            path: '/store/digital/:masechetid',
            name: ROUTE_STORE_DIGITAL_ITEM,
            component: StoreDigitalItemComponent
        },
        {
            path: '/store/cart',
            name: ROUTE_CART,
            component: CartComponent
        },
        {
            path: '/dedication',
            name: 'dedicationRoot',
            component: Donations
        },
        {
            path: '/caf',
            name: 'caf',
            component: Donations
        },
        {
            path: '/dedication/year',
            name: 'dedicationYear',
            component: ContactComponent
        },
        {
            path: '/dedication/day',
            name: ROUTE_DEDICATION_DAY,
            // component: DedicationDay
            component: ContactComponent
        },
        {
            path: '/dedication/masechet',
            name: 'dedicationMasechet',
            component: ContactComponent
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile
        },
        {
            path: '/about',
            name: ROUTE_ABOUT,
            component: About
        },
        {
            path: '/contact',
            name: 'contact',
            component: ContactComponent
        },
        {
            path: '/politica-de-privacidad',
            name: 'politica-de-privacidad',
            component: PoliticaDePrivacidad
        },
        {
            path: '/terminos-y-condiciones',
            name: 'terminos-y-condiciones',
            component: TerminosYCondiciones
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        }
        if (to.hash) {
          return { selector: to.hash };
        }
        return { x: 0, y: 0 };
      },
})

router.beforeEach((to, from, next) => {
    vanilla.scrollToTop()
    next()
})

const isLoggedIn = (to, from, next) => {
    if (store.getters[GET_LOGGED_IN]) {
        return next()
    }
    store.commit(SET_SIGNUP_SHOW_STATE, true)
    next(false)
    return null
}

router.afterEach((to, from) => {
    vanilla.setDocumentTitle('Jabrutouch')
    store.dispatch(A_AFTER_NAVIGATION, to)
})

export default router
